export const FIND_CURRENT_LOCATION = "FIND_CURRENT_LOCATION";
export const SET_CURRENT_LOCATION = "SET_CURRENT_LOCATION";
export const SET_LOCATION_QUERY = "SET_LOCATION_QUERY";
export const GET_SUGGESTIONS = "GET_SUGGESTIONS";
export const CLEAR_SUGGESTIONS = "CLEAR_SUGGESTIONS";



// WEBPACK FOOTER //
// ./src/services/location/constants.js